<template>
  <div class="LKPublicationsFormdataStatsList">
    <v-data-table
      v-model="selectedAte"
      :headers="headers"
      :items="list"
      :search="search"
      :loading="isLoading"
      :item-key="itemKey"
      :items-per-page="-1"
      disable-pagination
      disable-sort
      hide-default-footer
      single-select
      fixed-header
      :multi-sort="false"
      height="100%"
      dense
      class="LKPublicationsFormdataStatsList__table"
      @click:row="onClick"
    >
      <template #item.ate_name="{ item }">
        <div
          v-text="item.region_name || item.municipality_name"
        />
      </template>

      <template #item.percentage="{ item }">
        <v-chip
          :color="getColor(item.percentage)"
          dark
          class="percentage_item"
        >
          {{ item.percentage }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { LkPassportApi } from '@/api/resources'

export default {
  name: 'LKPublicationsFormdataStatsList',
  data: () => ({
    isLoading: false,
    list: [],
    selectedAte: [],
    search: '',
    headers: [
      { text: '', value: 'ate_name' },
      { text: 'Всего', value: 'all_count' },
      { text: 'Не приступал', value: 'not_started_count' },
      { text: 'В работе', value: 'in_progress_count' },
      { text: 'Сдано', value: 'submitted_count' },
      { text: '%', value: 'percentage' },
    ],
  }),
  computed: {
    itemKey() {
      if (this.list.length > 0) return this.list[0].region_id ? 'region_id' : 'municipality_id'
      return 'id'
    },
  },
  methods: {
    async asyncData() {
      this.isLoading = true
      try {
        const api = new LkPassportApi()
        const { data } = await api.getStatistics({
          is_active: true,
          is_filter: true,
        })
        if (Array.isArray(data)) {
          this.list = data
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    getColor(percent) {
      if (percent < 30) return 'red'
      if (percent < 80) return 'orange'
      return 'green'
    },
    onClick(item) {
      const [currentSelect] = this.selectedAte
      if (currentSelect === item) {
        this.selectedAte = []
        this.$emit('select', {
          region: null,
          municipality: null,
          school: null,
        })
        return
      }
      this.selectedAte = [item]
      this.$emit('select', {
        region: item.region_id ? {
          id: item.region_id,
          code: item.region_id,
          name: item.region_name,
        } : null,
        municipality: item.municipality_id ? {
          id: item.municipality_id,
          code: item.municipality_id,
          name: item.municipality_name,
        } : null,
        school: null,
      })
    },
  },
}
</script>
<style lang="scss">
.LKPublicationsFormdataStatsList {
  height: 100%;

  &__table {
    width: 100%;
    height: 100%;

    .percentage_item {
      min-width: 50px;
      text-align: center;

      .v-chip__content {
        justify-content: space-around;
        width: 100% !important;
        min-width: 100%;

        p {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
  .red {
    background-color: $color-error-dark !important;
  }

  .orange {
    background-color: $color-warning-dark !important;
  }

  .green {
    background-color: $color-success-dark !important;
  }
</style>
